(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('anomalyDetectionListConverter', ["$q", function ($q) {
        return function (input, args) {
            var rows = _(input.data).map(function (item, key) {
                item.id = key;
                return item;
            });
            return $q.when({ data: { rows: rows } });
        };
    }]);
}());